import React from 'react'

import RedirectSSO from '../components/login-modal/RedirectSSO'

const RedirectSSOScreen = props => <RedirectSSO {...props} />

export default RedirectSSOScreen
